export default __webpack_public_path__ + "static/media/pantry1-afterG-2048w.bf7e0b7d.png";